import React, { useEffect, useState } from "react";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import { useDispatch, useSelector } from "react-redux";
import {
   addLaneMasterAsync,
   getAllLaneAsync,
   getAllVendorAsync,
} from "../../../../redux/features/laneMaster";
import { FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { getFleetMasterDropdownDataAsync } from "../../../../redux/features/fleetMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import RouteNames from "../../../../AppRoutes/RouteName";
import validation from "../../../../helpers/validation";

const validationSchema = Yup.object().shape({
   lane_master_id: Yup.string().required("Lane Name is required"),
   vendor_master_id: Yup.string().required("Vendor Master ID is required"),
   origin: Yup.string().when("vendor_master_id", {
      is: (vendorId) => vendorId !== "Eisaku",
      then: () => Yup.string().notRequired(),
      otherwise: () => Yup.string().required("Origin is required"),
   }),
   destination: Yup.string().when("vendor_master_id", {
      is: (vendorId) => vendorId !== "Eisaku",
      then: () => Yup.string().notRequired(),
      otherwise: () => Yup.string().required("Destination is required"),
   }),
   driver_trip_advance: Yup.string().when("vendor_master_id", {
      is: (vendorId) => vendorId !== "Eisaku",
      then: () => Yup.string().notRequired(),
      otherwise: () => validation.amount("Driver Trip Advance"),
   }),
   trip_diesel_budget: Yup.string().when("vendor_master_id", {
      is: (vendorId) => vendorId !== "Eisaku",
      then: () => Yup.string().notRequired(),
      otherwise: () => validation.amount("Trip Diesel Budget"),
   }),
   trip_adblue_budget: Yup.string().when("vendor_master_id", {
      is: (vendorId) => vendorId !== "Eisaku",
      then: () => Yup.string().notRequired(),
      otherwise: () => validation.amount("Trip Adblue Budget"),
   }),
   trip_toll: Yup.string().when("vendor_master_id", {
      is: (vendorId) => vendorId !== "Eisaku",
      then: () => Yup.string().notRequired(),
      otherwise: () => validation.amount("Trip Toll"),
   }),
   tat: Yup.string().when("vendor_master_id", {
      is: (vendorId) => vendorId !== "Eisaku",
      then: () => Yup.string().notRequired(),
      otherwise: () => validation.hour("TAT"),
   }),
   vehicleType: Yup.string().when("vendor_master_id", {
      is: (vendorId) => vendorId !== "Eisaku",
      then: () => Yup.string().notRequired(),
      otherwise: () => Yup.string().required("Vehicle Type is required"),
   }),
   tonnage: Yup.string().when("vendor_master_id", {
      is: (vendorId) => vendorId !== "Eisaku",
      then: () => Yup.string().notRequired(),
      otherwise: () => Yup.string().required("Tonnage is required"),
   }),
   customerName: Yup.string().when("vendor_master_id", {
      is: (vendorId) => vendorId !== "Eisaku",
      then: () => Yup.string().notRequired(),
      otherwise: () => Yup.string().required("Customer Name is required"),
   }),
});

const initialValues = {
   lane_master_id: "",
   vendor_master_id: "",
   origin: "",
   destination: "",
   driver_trip_advance: "",
   trip_diesel_budget: "",
   trip_adblue_budget: "",
   trip_toll: "",
   tat: "",
   vehicleType: "",
   tonnage: "",
   customerName: "",
};

export default function LaneMasterAdd() {
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const laneMaster = useSelector((state) => state.laneMaster);
   const fleetMaster = useSelector((state) => state.fleetMaster);

   const locationData = fleetMaster?.location?.map?.((item) => ({
      label: item?.name,
      value: item?.id,
   }));
   const vehicleTypeData = fleetMaster?.vehicleCategory?.map?.((item) => ({
      label: item?.category_name,
      value: item?.id,
   }));
   const tonnageData = fleetMaster?.tonnage?.map?.((item) => ({
      label: item?.tonnage,
      value: item?.id,
   }));

   const laneData = laneMaster?.allLanes?.map?.((item) => ({
      ...item,
      label: item?.name,
      value: item?.id,
   }));
   const vendorData = laneMaster?.allVendors?.map?.((item) => ({
      ...item,
      label: item?.name,
      value: item?.id,
   }));

   const [makeSelect, setMake] = useState("");
   const [isDisabled, setIsdisabled] = useState(true);

   useEffect(() => {
      dispatch(getAllVendorAsync());
      dispatch(getAllLaneAsync());
      dispatch(getFleetMasterDropdownDataAsync());
   }, [dispatch]);

   const handleAddLane = (formData) => {
      const data = { ...formData };

      if (data.vendor_master_id !== "Eisaku") {
         [
            "origin",
            "destination",
            "driver_trip_advance",
            "trip_diesel_budget",
            "trip_adblue_budget",
            "trip_toll",
            "tat",
            "vehicleType",
            "tonnage",
            "customerName",
         ].forEach((key) => {
            delete data?.[key];
         });
      } else {
         delete data.vendor_master_id;
      }

      const newData = new FormData();

      Object.keys(data).forEach((key) => {
         newData.append(key, data[key]);
      });
      newData.append("model_id", 8);
      newData.append("action_id", 1);


      dispatch(backdropLoadingAction(true));
      dispatch(
         addLaneMasterAsync({
            data: newData,
            err: () => {
               toast.error("Something went wrong !");
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               toast.success("Record added successfully !");
               dispatch(backdropLoadingAction(false));
               navigate(RouteNames.laneMasterView);
            },
         })
      );
   };

   const formik = useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: handleAddLane,
   });

   const { touched, errors, getFieldProps, handleSubmit, setFieldValue } = formik;

   return (
      <FormikProvider value={formik}>
         <div>
            <BodyHeader title="Add Lane Master" />
            <form className="p-3 shadow-lg">
               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">Personal Details</h3>
                  </div>
                  <div className="card-body">
                     <div className="row">
                        <div className="col-lg-4">
                           <CustomDropdown
                              label="Lane Name"
                              optionData={laneData}
                              value={makeSelect}
                              onChange={(values) => {
                                 setFieldValue("lane_master_id", values?.[0]?.value);
                              }}
                              errors={
                                 Boolean(touched.lane_master_id) &&
                                 Boolean(errors.lane_master_id)
                              }
                              message={errors.lane_master_id}
                           />
                        </div>

                        <div className="col-lg-4">
                           {/* Dimension  */}
                           <CustomDropdown
                              label="Vendor Name"
                              optionData={[
                                 ...vendorData,
                                 { label: "Eisaku", value: "Eisaku" },
                              ]}
                              value={makeSelect}
                              onChange={(values) => {
                                 if (values?.[0].value === "Eisaku") {
                                    setIsdisabled(false);
                                 } else {
                                    setIsdisabled(true);
                                 }
                                 setFieldValue("vendor_master_id", values?.[0]?.value);
                              }}
                              errors={
                                 Boolean(touched.vendor_master_id) &&
                                 Boolean(errors.vendor_master_id)
                              }
                              message={errors.vendor_master_id}
                           />
                        </div>

                        <div className="col-lg-4">
                           {/* Financed by sec */}
                           <CustomDropdown
                              label="Origin"
                              optionData={locationData}
                              disabled={isDisabled}
                              onChange={(values) => {
                                 setFieldValue("origin", values?.[0]?.value);
                              }}
                              errors={Boolean(touched.origin) && Boolean(errors.origin)}
                              message={errors.origin}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDropdown
                              label="Destination"
                              optionData={locationData}
                              disabled={isDisabled}
                              onChange={(values) => {
                                 setFieldValue("destination", values?.[0]?.value);
                              }}
                              errors={
                                 Boolean(touched.destination) &&
                                 Boolean(errors.destination)
                              }
                              message={errors.destination}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Driver Trip Advance"
                              id="#tripadvance"
                              disabled={isDisabled}
                              placeholder="E.g. 500.00"
                              {...getFieldProps("driver_trip_advance")}
                              errors={
                                 Boolean(touched.driver_trip_advance) &&
                                 Boolean(errors.driver_trip_advance)
                              }
                              message={errors.driver_trip_advance}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Trip Diesel budget (ltr)"
                              id="#dieselBudget"
                              disabled={isDisabled}
                              placeholder="E.g. 500.00"
                              {...getFieldProps("trip_diesel_budget")}
                              errors={
                                 Boolean(touched.trip_diesel_budget) &&
                                 Boolean(errors.trip_diesel_budget)
                              }
                              message={errors.trip_diesel_budget}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Trip Adblue budget (ltr)"
                              id="#adblueBudget"
                              disabled={isDisabled}
                              placeholder="E.g. 500.00"
                              {...getFieldProps("trip_adblue_budget")}
                              errors={
                                 Boolean(touched.trip_adblue_budget) &&
                                 Boolean(errors.trip_adblue_budget)
                              }
                              message={errors.trip_adblue_budget}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Trip Toll"
                              id="#tripToll"
                              disabled={isDisabled}
                              placeholder="E.g. 500.00"
                              {...getFieldProps("trip_toll")}
                              errors={
                                 Boolean(touched.trip_toll) && Boolean(errors.trip_toll)
                              }
                              message={errors.trip_toll}
                           />
                        </div>

                        <div className="col-lg-4">
                           {/* Vehicle Type  */}
                           <CustomDropdown
                              label="Vehicle Type"
                              optionData={vehicleTypeData}
                              value={makeSelect}
                              disabled={isDisabled}
                              onChange={(values) => {
                                 setFieldValue("vehicleType", values?.[0]?.value);
                              }}
                              errors={
                                 Boolean(touched.vehicleType) &&
                                 Boolean(errors.vehicleType)
                              }
                              message={errors.vehicleType}
                           />
                        </div>

                        <div className="col-lg-4">
                           {/* Tonnage */}
                           <CustomDropdown
                              label="Tonnage"
                              optionData={tonnageData}
                              value={makeSelect}
                              disabled={isDisabled}
                              onChange={(values) => {
                                 setFieldValue("tonnage", values?.[0]?.value);
                              }}
                              errors={Boolean(touched.tonnage) && Boolean(errors.tonnage)}
                              message={errors.tonnage}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Customer Name (Including broker)"
                              id="#nameBroker"
                              disabled={isDisabled}
                              placeholder="Broker"
                              {...getFieldProps("customerName")}
                              errors={
                                 Boolean(touched.customerName) &&
                                 Boolean(errors.customerName)
                              }
                              message={errors.customerName}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="TAT (in Hrs)"
                              id="#tat"
                              disabled={isDisabled}
                              inputType="number"
                              placeholder="2 Hrs"
                              {...getFieldProps("tat")}
                              errors={Boolean(touched.tat) && Boolean(errors.tat)}
                              message={errors.tat}
                           />
                        </div>
                     </div>
                  </div>
               </div>
               <div className="col-12 mt-3 text-center">
                  <button
                     className="btn btn-primary px-4 py-3"
                     type="button"
                     onClick={handleSubmit}
                  >
                     <h5 className="mb-0 text-uppercase">Submit</h5>
                  </button>
               </div>
            </form>
         </div>
      </FormikProvider>
   );
}
